var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 69.5,
    height: 69.5,
    rx: 34.75,
    fill: "#259F64",
    stroke: "#259F64",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_315_414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6403 41.7271L48.4868 23.4553C50.4161 21.5839 53.0433 21.4644 54.7821 23.1654C56.5209 24.8665 56.388 27.3782 54.4636 29.2433L32.8815 50.1734C30.898 52.0942 28.394 52.0942 26.4088 50.1734C22.7571 46.6332 19.107 43.0931 15.4585 39.553C13.5982 37.7501 13.5095 35.2033 15.2418 33.5341C16.9741 31.8649 19.5865 31.9701 21.4189 33.7475L29.6403 41.7271Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_315_414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 29.6471,
    fill: "white",
    transform: "translate(14 21.9609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.a9fab36bdba6a61b3e3d03963119e16c.svg";
export { ForwardRef as ReactComponent };